import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";
import { CameraOff, Flashlight } from "lucide-react";

const FORMATS = [Html5QrcodeSupportedFormats.QR_CODE, Html5QrcodeSupportedFormats.CODE_128, Html5QrcodeSupportedFormats.CODE_39,
  Html5QrcodeSupportedFormats.EAN_13, Html5QrcodeSupportedFormats.DATA_MATRIX];

export function CameraView({ onCode }) {
  const ref = useRef(null);
  const [err, setErr] = useState(null);
  const [torch, setTorch] = useState(null);
  const done = useRef(false);

  useEffect(() => {
    const el = "scanner-camera";
    const qr = new Html5Qrcode(el, { formatsToSupport: FORMATS, verbose: false });
    ref.current = qr;
    qr.start({ facingMode: "environment" }, { fps: 12, qrbox: (w, h) => ({ width: Math.min(w, h) * 0.75, height: Math.min(w, h) * 0.75 }) },
      (text) => {
        if (done.current) return;
        done.current = true;
        if (navigator.vibrate) navigator.vibrate(60);
        onCode(text);
      }, () => {})
      .then(() => {
        try { const caps = qr.getRunningTrackCapabilities(); if (caps.torch) setTorch(false); } catch { /* no torch */ }
      })
      .catch((e) => setErr(String(e?.message || e).includes("ermission") ? "Camera permission was blocked. Allow camera access in your browser settings, or type the code below." : "Camera not available on this device. Type the code below instead."));
    return () => { if (qr.isScanning) qr.stop().then(() => qr.clear()).catch(() => {}); };
  }, [onCode]);

  const toggleTorch = async () => {
    try { await ref.current.applyVideoConstraints({ advanced: [{ torch: !torch }] }); setTorch(!torch); } catch { /* unsupported */ }
  };

  return (
    <div className="relative mx-auto aspect-square w-full max-w-[min(100%,52vh)] overflow-hidden rounded-xl bg-black" data-testid="scanner-camera-wrap">
      <div id="scanner-camera" className="absolute inset-0 [&_video]:!h-full [&_video]:!w-full [&_video]:object-cover" />
      {err && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 p-6 text-center text-sm text-white/80" data-testid="scanner-error">
          <CameraOff size={28} /> {err}
        </div>
      )}
      {torch !== null && (
        <button type="button" onClick={toggleTorch} data-testid="scanner-torch"
          className={`absolute bottom-3 right-3 flex h-11 w-11 items-center justify-center rounded-full ${torch ? "bg-amber-400 text-black" : "bg-white/20 text-white"} backdrop-blur`}>
          <Flashlight size={18} />
        </button>
      )}
    </div>
  );
}
